<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <div class="modal-card">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">
          {{ action }}
        </h1>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column">
            <b-field label="Date">
              <b-input
                name="date"
                v-model="editObjectName.timestamp"
                required
                :disabled="!isAdd"
              />
            </b-field>
            <b-field label="Subject">
              <b-input
                name="subject"
                v-model="editObjectName.subject"
                required
                :disabled="!isAdd"
              />
            </b-field>
            <b-field label="Sender">
              <b-input
                name="email"
                v-model="editObjectName.email"
                required
                :disabled="!isAdd"
              />
            </b-field>
            <b-field label="Receiver CC">
              <b-input
                name="cc"
                v-model="editObjectName.cc"
                required
                :disabled="!isAdd"
              />
            </b-field>
            <b-field label="Receiver BCC">
              <b-input
                name="bcc"
                v-model="editObjectName.bcc"
                required
                :disabled="!isAdd"
              />
            </b-field>
            <b-field label="Content">
              <b-input
                name="content"
                textarea
                v-model="editObjectName.content"
                required
                :disabled="!isAdd"
              />
            </b-field>
            <b-field label="Content Text">
              <b-input
                name="content_text"
                textarea
                v-model="editObjectName.content_text"
                required
                :disabled="!isAdd"
              />
            </b-field>
            <b-field label="Status">
              <b-input
                name="status"
                textarea
                v-model="editObjectName.status"
                required
                :disabled="!isAdd"
              />
            </b-field>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot" v-if="isAdd">
        <b-button
          slot="right"
          native-type="submit"
          type="is-primary"
          v-on:click="submit"
          :disabled="disabledSubmitButton"
        >
          Save
        </b-button>
        <b-button slot="right" type="is-danger" @click="cancel">
          Cancel
        </b-button>
      </footer>
      <footer class="modal-card-foot" v-if="!isAdd">
        <b-button
          v-if="disable && this.action !== 'View'"
          slot="right"
          type="is-danger"
          @click="removeCommunication"
        >
          Delete
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import CommunicationService from "@/services/CommunicationService";
import CustomerProfileDataService from "../../services/CustomerProfileDataService";
export default {
  name: "CommunicationAddView",
  props: {
    action: {
      type: String,
      default: "Inserts"
    },
    isAdd: {
      type: Boolean,
      default: true
    },
    isEdit: {
      type: Boolean,
      default: true
    },
    isActive: {
      type: Boolean,
      default: false
    },
    editObjectName: {
      type: Object,
      default: () => {
        return {
          id: null,
          date: null,
          subject: null,
          receiver: null,
          body: null,
          attachment: null
        };
      }
    },
    customerId: {
      type: Number,
      default: -1
    },
    isDelete: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      isModalActive: false,
      disabledSubmitButton: false,
      communicationService: new CommunicationService(),
      customerDataService: new CustomerProfileDataService()
    };
  },
  mounted() {
    this.checkValues();
  },
  computed: {
    disable() {
      if (this.action == "Edit") {
        return false;
      } else if (this.action == "View") {
        return true;
      } else if (this.action == "Delete") {
        return true;
      }
      return false;
    }
  },
  methods: {
    cancel() {
      this.disabledSubmitButton = true;
      this.$emit("cancel");
    },
    confirm() {
      this.$emit("confirm");
    },
    checkValues() {
      if (
        this.editObjectName.date &&
        this.editObjectName.subject &&
        this.editObjectName.receiver
      ) {
        this.disabledSubmitButton = false;
      } else {
        this.disabledSubmitButton = true;
      }
    },
    handleApiError(reason) {
      let errorMessage = "";
      for (const v in reason.response.data) {
        errorMessage += v + ": " + reason.response.data[v] + "<br>";
      }

      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
      });
    },
    prepareMasterData(data) {
      const resultDict = {};
      for (const idx in data) {
        const dataDict = data[idx];
        resultDict[dataDict["id"]] = dataDict["name"];
      }
      return resultDict;
    },
    submit() {
      if (this.action == "Add") {
        this.communicationService
          .create(this.editObjectName)
          .subscribe(response => {
            this.$buefy.dialog.alert({
              title: "Success",
              message: "Communication Created!"
            });
            this.$emit("confirm", response);
          }, this.handleApiError);
      } else if (this.action == "Update") {
        this.communicationService
          .update(this.editObjectName)
          .subscribe(response => {
            this.$buefy.dialog.alert({
              title: "Success",
              message: "Communication Updated!"
            });
            this.$emit("confirm", response);
          }, this.handleApiError);
      }
    },
    removeCommunication() {
      this.communicationService
        .delete(this.editObjectName.id)
        .subscribe(response => {
          this.$emit("confirm", response);
          this.$buefy.dialog.alert({
            title: "Success",
            message: "Communication Removed!"
          });
        }, this.handleApiError);
    }
  },
  watch: {
    editObjectName() {
      this.checkValues();
    },
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  }
};
</script>
